var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.075 198.8H117.505L197.025 19.1699H244.95L165.075 198.8Z",
    fill: "#25BECB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.075 198.8H117.505L197.025 19.1699H244.95L165.075 198.8Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.075 198.8L145.905 134.9L141.29 144.84L165.075 198.8Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.15 89.8149H69.5798L117.505 198.8H165.075L117.15 89.8149Z",
    fill: "#49BC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.15 89.8149H69.5798L117.505 198.8H165.075L117.15 89.8149Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.275 264.475H31.95V241.045H37.63V264.475H37.275Z",
    fill: "#49BC99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3849 257.73C66.3849 261.635 63.8999 264.475 57.5099 264.475H46.1499V241.045H56.4449C63.1899 241.045 65.3199 243.885 65.3199 247.435C65.3199 249.92 63.5449 251.695 63.1899 252.05C65.3199 253.115 66.3849 255.245 66.3849 257.73ZM59.6399 248.145C59.6399 246.725 58.5749 245.66 56.4449 245.66H51.4749V250.63H56.4449C58.9299 250.63 59.6399 249.92 59.6399 248.145ZM56.7999 254.89H51.4749V259.505H56.7999C58.9299 259.505 60.3499 258.795 60.3499 257.375C60.3499 255.6 59.2849 254.89 56.7999 254.89Z",
    fill: "#49BC99"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5201 264.475H73.8401V241.045H79.5201V264.475Z",
    fill: "#49BC99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.145 248.5H100.465C100.465 247.435 99.045 245.66 96.56 245.66C94.785 245.66 92.655 246.37 92.655 247.79C92.655 248.855 94.075 249.21 97.625 250.275C101.175 251.34 106.5 252.405 106.5 257.73C106.5 262.345 102.595 264.83 97.27 264.83C89.815 264.83 86.975 259.86 86.975 256.31H92.655C92.655 256.31 93.01 259.86 97.625 259.86C100.11 259.86 101.175 258.795 101.175 257.73C101.175 256.31 99.045 255.6 96.915 255.245C93.365 254.535 87.33 253.115 87.33 247.79C87.33 243.53 91.59 240.335 96.915 240.335C102.95 240.69 106.145 244.595 106.145 248.5Z",
    fill: "#49BC99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.09 264.475H121.055L110.76 241.045H117.15L124.25 257.73L131.35 241.045H137.74L127.09 264.475Z",
    fill: "#25BECB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.165 264.475H144.485V241.045H150.165V264.475Z",
    fill: "#25BECB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.145 248.5H171.465C171.465 247.435 170.045 245.66 167.56 245.66C165.785 245.66 163.655 246.37 163.655 247.79C163.655 248.855 165.075 249.21 168.625 250.275C172.175 251.34 177.5 252.405 177.5 257.73C177.5 262.345 173.595 264.83 168.27 264.83C160.815 264.83 157.975 259.86 157.975 256.31H163.655C163.655 256.31 164.01 259.86 168.625 259.86C171.11 259.86 172.175 258.795 172.175 257.73C172.175 256.31 170.045 255.6 167.915 255.245C164.365 254.535 158.33 253.115 158.33 247.79C158.33 243.53 162.59 240.335 167.915 240.335C173.95 240.69 177.145 244.595 177.145 248.5Z",
    fill: "#25BECB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.99 264.475H185.31V241.045H190.99V264.475Z",
    fill: "#25BECB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.23 252.76C222.23 259.505 216.905 264.83 210.16 264.83C203.415 264.83 198.09 259.505 198.09 252.76C198.09 246.015 203.415 240.69 210.16 240.69C216.905 240.69 222.23 246.015 222.23 252.76ZM203.06 252.76C203.06 256.665 206.255 259.505 209.805 259.505C213.71 259.505 216.55 256.31 216.55 252.76C216.55 248.855 213.355 246.015 209.805 246.015C206.255 245.66 203.06 248.855 203.06 252.76Z",
    fill: "#25BECB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M252.05 264.475H246.37L234.655 250.275V264.475H228.975V241.045H234.655L246.37 255.245V241.045H252.05V264.475Z",
    fill: "#25BECB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 138.758,
    y1: 198.119,
    x2: 222.526,
    y2: 21.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BECB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 141.389,
    y1: 166.719,
    x2: 165.085,
    y2: 166.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BECB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 138.949,
    y1: 195.357,
    x2: 93.5328,
    y2: 88.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49BC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BC99",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bfc859ee4ce344e5af0f470f95373b08.svg";
export { ForwardRef as ReactComponent };